import { ValidationErrors } from '@angular/forms';

import { v4 as uuid } from 'uuid';

import { ProductItem } from '@ph-model/response';

import { Field } from '../../../../../model/form/field';

export type CartItemErrorTypes = 'DUPL' | 'ECON' | 'UNAV' | 'MULTI' | 'COST' | 'CREATE-CONTRACT-FAILURE' | ''

export class CartItem {
  product: ProductItem;
  key: string;
  valid: boolean;
  message: string[];
  customerTaxForm: Field[];
  dealerTaxForm: Field[];
  formValid: boolean;
  errorType: CartItemErrorTypes[];
  errors: ValidationErrors | null | undefined;

  constructor(product: ProductItem) {
    this.product = product;
    this.valid = true;
    this.customerTaxForm = [];
    this.dealerTaxForm = [];
    this.key = uuid();
    this.message = [];
    this.formValid = true;
    this.errorType = [];
  }
}
